import {useMutation} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {userProfileUrl} from "../../constants/api/endpoints";
import {INewUser} from "../../constants/types/INewUser";

export const useMutateEditUser = () => {
  const axios = useAxios();

  return useMutation({
    mutationKey: ['edit-user'],
    mutationFn: async (data: INewUser) => {
      const response = await axios.patch(
        userProfileUrl,
        data
      );
      return response.data;
    },
    retry: 1
  });
};